import { useUnit } from "@/context/UnitContext";

/**
 * Small cm / in toggle for dimension inputs. Switching converts any values the
 * parent is holding (parent passes an onSwitch(from, to) to run the conversion).
 */
export function UnitToggle({ onSwitch, className = "" }) {
  const { unit, setUnit } = useUnit();
  function pick(next) {
    if (next === unit) return;
    const prev = unit;
    setUnit(next);
    onSwitch?.(prev, next);
  }
  return (
    <div className={`inline-flex rounded-full border border-slate-300 overflow-hidden text-xs font-semibold ${className}`} data-testid="unit-toggle">
      {["cm", "in"].map((u) => (
        <button
          key={u}
          type="button"
          onClick={() => pick(u)}
          className={`px-3 h-7 transition-colors ${unit === u ? "bg-[#0F3D2E] text-white" : "bg-white text-slate-600 hover:bg-slate-50"}`}
          data-testid={`unit-${u}`}
          aria-pressed={unit === u}
        >
          {u}
        </button>
      ))}
    </div>
  );
}
